import Stack from '@eversports/klimt-primitives/legacy/Stack'
import { UserFeaturePreviews } from '@eversports/react-app-base/user-feature-previews'

import useEnabledFeaturePreviews from '../../../../hooks/useEnabledFeaturePreviews'
import { VenueReferAFriendButton } from '../ReferAFriendButton/VenueReferAFriendButton'

import VenueProfileFavoriteButton from './VenueProfileFavoriteButton'
import VenueShareButton from './VenueShareButton'

const FavoriteAndShareButtons = () => {
  const enabledFeaturePreviews = useEnabledFeaturePreviews()
  const isReferAFriendEnabled = enabledFeaturePreviews.includes(UserFeaturePreviews.USER_REFER_A_FRIEND)

  return (
    <Stack
      gap={3}
      zIndex={1}
      direction="row"
      alignItems="align-start"
      flexShrink={0}
      sx={{ position: { xs: 'absolute', sm: 'initial' }, top: 12, right: 12 }}
    >
      <VenueProfileFavoriteButton />
      <VenueShareButton />
      {isReferAFriendEnabled && <VenueReferAFriendButton />}
    </Stack>
  )
}

export default FavoriteAndShareButtons
